import axios from 'axios'
import SearchUrlBuilder from '@/core/utils/SearchUrlBuilder'

class AgendaApiClient {

    async buscarDentistas() {
        return axios.get('/dentista/buscarDentistas')
    }

    async buscarTodosSemPaginacao(conteudo) {
        let url = '/dentista/pesquisaDentista'
        if(conteudo)
            url = `/dentista/pesquisaDentista?conteudo=${conteudo}`
        return axios.get(url)
    }

    async editarDetalhesDentista(dados) {
        return axios.put('/dentista/atualizarAtributos', dados)
    }

    async buscarEventos(dados) {
        const url = SearchUrlBuilder.buildAvanced('/agenda/buscarEventosPorPeriodo', dados)
        return axios.get(url)
    }

    async adicionarEvento(dados) {
        return axios.post('/agenda/cadastrarEventoAgenda', dados)
    }

    async removerEvento(eventoId) {
        return axios.delete(`/agenda/deletar/${eventoId}`)
    }

    async editarEvento(dados) {
        return axios.put('/agenda/editarEventoAgenda', dados)
    }

}

export default new AgendaApiClient()
